import { generateOneLinkURL } from "./af-smart-script";
import noticeError from "./notice-error";
import QRCode from "qrcode";

export default function renderQRCode(
  oneLinkURL,
  mediaSource,
  campaign,
  deepLinkValue,
  channel
) {
  const result = generateOneLinkURL({
    oneLinkURL,
    afParameters: {
      mediaSource,
      campaign,
      deepLinkValue,
      channel,
    },
  });

  if (result?.clickURL) {
    const result_url = result.clickURL;
    const qrTargetId = "qr-target";
    const qrTargetWrapper = document.createElement("a");
    qrTargetWrapper.href = result_url;
    const qrTarget = document.createElement("canvas");
    qrTarget.id = qrTargetId;
    qrTarget.style.borderRadius = "10px";

    qrTargetWrapper.appendChild(qrTarget);

    const qrEl = document.querySelector(".description-container_qrCode");

    if (qrEl && qrEl.querySelector(`#${qrTargetId}`)) {
      return; // QR code already rendered
    }

    qrEl.insertAdjacentElement("afterbegin", qrTargetWrapper);

    QRCode.toCanvas(
      qrTarget,
      "".concat(result_url, "&af_ss_qr=true"),
      {
        scale: 2,
      },
      (error) => {
        if (error) {
          noticeError(`something terrible happened rendering qr code`, error);
        }
      }
    );
  }
}
